/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { Schema } from '@jalik/schema'
import { DAYS, MONTHS, YEARS } from '../enums/DurationUnits.mjs'

const LeaseTemplateSchema = new Schema({
  duration: {
    type: 'number',
    min: 0,
    required: true
  },
  durationUnit: {
    type: 'string',
    allowed: [YEARS, MONTHS, DAYS],
    required: true
  },
  furnished: {
    type: 'boolean',
    required: true
  },
  managed: {
    type: 'boolean',
    required: true
  },
  name: {
    type: 'string',
    maxLength: 100,
    required: true
  },
  noticeDuration: {
    type: 'number',
    min: 0,
    required: true
  },
  noticeDurationUnit: {
    type: 'string',
    allowed: [YEARS, MONTHS, DAYS],
    required: true
  }
})

export default LeaseTemplateSchema
